<template>
  <div class="registros-container">
    <h2>Registros</h2>
    <el-card>
      <div>Contenido de la vista Registros</div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BotRegistros'
}
</script>

<style lang="scss" scoped>
.registros-container {
  padding: 20px;
}
</style> 